import axios, {
  AxiosError,
  AxiosHeaderValue,
  AxiosInstance,
  CreateAxiosDefaults,
} from "axios";

import config from "../config";

enum ApiErrorMessages {
  Generic = "Something went wrong.",
  NoConnection = "Connection not found.",
  BadRequest = "Incorrect request, please try again.",
}

export const apiErrorGeneric: IApiError = {
  isSuccessful: false,
  message: ApiErrorMessages.Generic,
};

export const getAxiosInstance = async (): Promise<AxiosInstance> => {
  /**
   * Get an Axios instance with the configuration for this project.
   */
  const headers: { [key: string]: AxiosHeaderValue } = {};
  const token = localStorage.getItem("token");
  if (token) {
    headers["Authorization"] = `Token ${token}`;
  }
  const axiosConfiguration: CreateAxiosDefaults = {
    baseURL: `${config.backendBaseUrl}/rest-api/`,
    headers: headers,
  };
  return axios.create(axiosConfiguration);
};

export const handleAxiosError = async (
  error: AxiosError,
): Promise<IApiError> => {
  /**
   * Handling an Axios error.
   */

  // Handle server-returned errors.
  if (error?.response?.status) {
    if ([401].includes(error.response.status)) {
      const data = error.response.data as IAxiosResponseData;
      if (data?.detail === "Ongeldige token.") {
        // Delete invalid token.
        localStorage.removeItem("token");
      }
      return {
        isSuccessful: false,
        message: ApiErrorMessages.Generic,
        statusCode: error.response.status,
      } as IApiError;
    } else if ([400, 409, 422].includes(error.response.status)) {
      // Bad request (or similar), so return error data (i.e. form validation errors).
      return {
        isSuccessful: false,
        message: ApiErrorMessages.BadRequest,
        data: error.response?.data,
        statusCode: error.response.status,
      } as IApiError;
    } else {
      // Any other (internal server or unexpected) errors.
      return { ...apiErrorGeneric, statusCode: error.response.status };
    }
  }
  // Handle network errors.
  else if (error?.code === AxiosError.ERR_NETWORK) {
    // This could also mean that our server is down,
    // but more likely it's a network error on the user's side.
    return {
      isSuccessful: false,
      message: ApiErrorMessages.NoConnection,
    } as IApiError;
  }
  // Any other (unexpected) errors.
  return apiErrorGeneric;
};
